<app-page-heading [heading]="heading"
                  [hasBackButton]="true"
                  [backPageName]="backPageName"
                  [customRoute]="customRoute"
                  [tabName]="tabName">
</app-page-heading>

<greydom-info-panel *ngIf="application && externalStatus"
                    [messageCounter]="getMessageCountForStatus()"
                    [topic]="getApplicationStatus()"
                    [message]="getApplicationStatusMessage()"
                    [iconClickable]="true"
                    (iconClick)="onClickOpenReport($event, application?.applicationId)"></greydom-info-panel>

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav mode="side" opened>
    <mat-nav-list>
      <a mat-list-item *ngFor="let item of visibleNavItems" [class.active]="selectedTab === item.value"
         (click)="selectedTab = item.value">
        <mat-icon matListItemIcon class="table-icon">{{ item.icon }}</mat-icon>
        <span class="ml1" matListItemTitle>{{ item.name }}</span>
      </a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <ng-container *ngIf="application; else loading">
      <ng-container [ngSwitch]="selectedTab">
        <greydom-application-summary *ngSwitchCase="ApplicationTab.Summary"
                                     [application]="application"
                                     [diagnosisGroups]="diagnosisGroups"
                                     [userFirstLastName]="userFirstLastName"
                                     (dispatchFetchApplicationRequest)="handleReFetchApplication($event)"></greydom-application-summary>
        <greydom-application-bank-details *ngSwitchCase="ApplicationTab.BankDetails" [application]="application"
                                          [userFirstLastName]="userFirstLastName"></greydom-application-bank-details>
        <greydom-application-addresses *ngSwitchCase="ApplicationTab.Addresses" [application]="application"
                                       [userFirstLastName]="userFirstLastName"></greydom-application-addresses>
        <greydom-application-documents *ngSwitchCase="ApplicationTab.Documents"
                                       [application]="application"></greydom-application-documents>
        <greydom-application-family-providers *ngSwitchCase="ApplicationTab.FamilyProviders"
                                              [application]="application"></greydom-application-family-providers>
        <greydom-application-smses *ngSwitchCase="ApplicationTab.SMSes"
                                   [application]="application"></greydom-application-smses>
        <greydom-application-emails *ngSwitchCase="ApplicationTab.Emails"
                                    [application]="application"></greydom-application-emails>
      </ng-container>
    </ng-container>
    <ng-template #loading>
      <label>Fetching application details...</label>
    </ng-template>
  </mat-sidenav-content>
</mat-sidenav-container>
